import { isSessionActivelyRunning } from "~/lib/threadRuntimeState";
import { isSidebarThreadVisible } from "./threadVisibility";

export interface SidebarProjectedThreadShape {
  readonly archivedAt?: string | null;
  readonly kind?: string | null;
  readonly session: {
    readonly status?: string | null;
    readonly activeTurnId?: string | null | undefined;
  } | null;
}

export interface SidebarThreadProjection<TThread extends SidebarProjectedThreadShape> {
  readonly visibleThreads: readonly TThread[];
  readonly liveTopLevelCount: number;
}

/**
 * Canonical sidebar thread projection used by both:
 *  - left-nav live badge count
 *  - workspace/thread rendering
 *
 * This keeps "live" and "visible in sidebar" sourced from the same filtered set.
 */
export function projectSidebarThreads<TThread extends SidebarProjectedThreadShape>(
  threads: readonly TThread[],
): SidebarThreadProjection<TThread> {
  const visibleThreads = threads.filter((thread) => isSidebarThreadVisible(thread));
  const liveTopLevelCount = visibleThreads.filter(
    (thread) => thread.kind !== "worker" && isSessionActivelyRunning(thread.session),
  ).length;
  return { visibleThreads, liveTopLevelCount };
}
